import React, { useEffect, useState } from "react";
import "./css.css";
import { useNavigate } from "react-router-dom";
import { MDBBtn, MDBContainer, MDBRadio } from "mdb-react-ui-kit";
import { Button } from "react-bootstrap";
import {Form as Form1} from "react-bootstrap/Form";
import { db } from "../config_firebase";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import {
  collection,
  addDoc,
  getDocs,
  doc,
} from "firebase/firestore";

/**
 * @author
 * @function Login
 *
 **/

 export const Questionnaire = (props) => {
    const history = useNavigate();
    const [url, setUrl] = useState(window.location.href);
    const [userId, setUserId] = useState("");

    async function addclick(data) {
      const docRef = await addDoc(collection(db, "clicksdata"), {
        data,
      });
    }
    
    async function addUser(data) {
      const docRef = await addDoc(collection(db, "usersdata"), {
        data,
      });
    }

    useEffect(() => {
        const iosa = url.split(",");
        setUserId(iosa[1]);
      }, []);

    return(
      <div className="survey">
        <div className="justify-content-center">
          <h1>Thank you, you have finished the task.</h1>
          <h3>Now, please answer the following questions:</h3>
          <Formik
            initialValues={{gender: "", age:""}}
            onSubmit={(values) => {
              localStorage.setItem("age",values.age);
              localStorage.setItem("gender",values.gender);
              localStorage.setItem("education",values.education);
              localStorage.setItem("device",values.device);
              localStorage.setItem("source",values.source);
              localStorage.setItem("credibility",values.credibility);
              localStorage.setItem("preceived_credibility",values.preceived_credibility);
              localStorage.setItem("effort",values.effort);
              localStorage.setItem("realistic",values.realistic);
              localStorage.setItem("knowledge",values.knowledge);
              localStorage.setItem("free_text",values.free_text);

              const questionnaire_button = {
                time: Date.now(),
                userId: localStorage.getItem("user_id"),
                buttonType: "questionnaire_button",
              };
              addclick(questionnaire_button);
      
              const user = {
                userId: localStorage.getItem("user_id"),
                user_group: localStorage.getItem("random_group"),//
                page0_prediction: localStorage.getItem("page0_prediction"),
                page0_confidence: localStorage.getItem("page0_confidence"),
                page0A_prediction: localStorage.getItem("page0A_prediction"),
                page0A_confidence: localStorage.getItem("page0A_confidence"),

                page1_prediction: localStorage.getItem("page1_prediction"),
                page1_confidence: localStorage.getItem("page1_confidence"),
                page1A_prediction: localStorage.getItem("page1A_prediction"),
                page1A_confidence: localStorage.getItem("page1A_confidence"),

                page2_prediction: localStorage.getItem("page2_prediction"),
                page2_confidence: localStorage.getItem("page2_confidence"),
                page2A_prediction: localStorage.getItem("page2A_prediction"),
                page2A_confidence: localStorage.getItem("page2A_confidence"),

                page3_prediction: localStorage.getItem("page3_prediction"),
                page3_confidence: localStorage.getItem("page3_confidence"),
                page3A_prediction: localStorage.getItem("page3A_prediction"),
                page3A_confidence: localStorage.getItem("page3A_confidence"),

                page4_prediction: localStorage.getItem("page4_prediction"),
                page4_confidence: localStorage.getItem("page4_confidence"),
                page4A_prediction: localStorage.getItem("page4A_prediction"),
                page4A_confidence: localStorage.getItem("page4A_confidence"),

                age: localStorage.getItem("age"),
                gender: localStorage.getItem("gender"),
                education: localStorage.getItem("education"),
                device: localStorage.getItem("device"),
                source: localStorage.getItem("source"),
                credibility: localStorage.getItem("credibility"),
                preceived_credibility: localStorage.getItem("preceived_credibility"),
                effort: localStorage.getItem("effort"),
                realistic: localStorage.getItem("realistic"),
                knowledge: localStorage.getItem("knowledge"),
                free_text: localStorage.getItem("free_text")
              };
              history(`/endscreen/?,${userId}`);
              addUser(user);

            }}
            validationSchema={Yup.object({
              age: Yup.number()
              .max(100)
              .min(1)
              .required(),
            })}
          >
            {(formik, isSubmitting) => (
              <Form>
                <div className="col-sm-2">
                  <label htmlFor="age"> Please enter your age </label>
                  <Field 
                  name="age" 
                  className={formik.touched.age && formik.errors.age 
                    ? "form-control is-invalid" 
                    : "form-control"
                  } 
                  type="text"/>
                </div>

                <div className="col-form-label">
                  <label htmlFor="gender">What is your gender?</label><br />
                  <div className="radio">
                    <div className="form-check form-check-inline">
                        <Field name="gender" className="form-check-input" type="radio" value="male" required/> 
                        <label htmlFor="gender">Male</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="gender" className="form-check-input" type="radio" value="female" required/> 
                        <label htmlFor="gender">Female</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="gender" className="form-check-input" type="radio" value="other" required/> 
                        <label htmlFor="gender">Other</label>
                    </div>
                  </div>
                </div>

                <div className="col-form-label">
                  <label htmlFor="education">Choose your level of education</label><br />
                  <div className="radio">
                    <div className="form-check form-check-inline">
                        <Field name="education" className="form-check-input" type="radio" value="1" required/> 
                        <label htmlFor="education">Less than highschool</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="education" className="form-check-input" type="radio" value="2" required/> 
                        <label htmlFor="education">Highschool</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="education" className="form-check-input" type="radio" value="3" required/> 
                        <label htmlFor="education">First degree</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="education" className="form-check-input" type="radio" value="4" required/> 
                        <label htmlFor="education">Second degree</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="education" className="form-check-input" type="radio" value="5" required/> 
                        <label htmlFor="education">Third degree</label>
                    </div>
                  </div>
                </div>

                <div className="col-form-label">
                  <label htmlFor="device">Which device did you preform the experiment with?</label><br />
                  <div className="radio">
                    <div className="form-check form-check-inline">
                        <Field name="device" className="form-check-input" type="radio" value="laptop" required/> 
                        <label htmlFor="device">Laptop</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="device" className="form-check-input" type="radio" value="tablet" required/> 
                        <label htmlFor="device">Tablet</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="device" className="form-check-input" type="radio" value="desktop" required/> 
                        <label htmlFor="device">Desktop computer</label>
                    </div>
                  </div>
                </div>

                <div className="col-form-label">
                  <label htmlFor="source">In the study you received recommendations from:</label><br />
                  <div className="radio">
                    <div className="form-check form-check-inline">
                        <Field name="source" className="form-check-input" type="radio" value="AI" required/> 
                        <label htmlFor="source">AI algorithm</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="source" className="form-check-input" type="radio" value="human" required/> 
                        <label htmlFor="source">Stock market expert</label>
                    </div>
                  </div>
                </div>

                <div className="col-form-label">
                  <label htmlFor="credibility">What is the success rate of the recommendation source?</label><br />
                  <div className="radio">
                    <div className="form-check form-check-inline">
                        <Field name="credibility" className="form-check-input" type="radio" value="50%" required/> 
                        <label htmlFor="credibility">50%</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="credibility" className="form-check-input" type="radio" value="90%" required/> 
                        <label htmlFor="credibility">90%</label>
                    </div>
                  </div>
                </div>

                <div className="col-form-label">
                  <label htmlFor="preceived_credibility">How do you perceive the credibility of the recommendation source based on their performance during the task? (1-Very bad, 5-Very good)</label><br />
                  <div className="radio">
                    <div className="form-check form-check-inline">
                        <Field name="preceived_credibility" className="form-check-input" type="radio" value="1" required/> 
                        <label htmlFor="preceived_credibility">1</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="preceived_credibility" className="form-check-input" type="radio" value="2" required/> 
                        <label htmlFor="preceived_credibility">2</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="preceived_credibility" className="form-check-input" type="radio" value="3" required/> 
                        <label htmlFor="preceived_credibility">3</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="preceived_credibility" className="form-check-input" type="radio" value="4" required/> 
                        <label htmlFor="preceived_credibility">4</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="preceived_credibility" className="form-check-input" type="radio" value="5" required/> 
                        <label htmlFor="preceived_credibility">5</label>
                    </div>
                  </div>
                </div>


                <div className="col-form-label">
                  <label htmlFor="effort">How much effort did you put into completing the task? (1-Not at all, 5-A lot)</label><br />
                  <div className="radio">
                    <div className="form-check form-check-inline">
                        <Field name="effort" className="form-check-input" type="radio" value="1" required/> 
                        <label htmlFor="effort">1</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="effort" className="form-check-input" type="radio" value="2" required/> 
                        <label htmlFor="effort">2</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="effort" className="form-check-input" type="radio" value="3" required/> 
                        <label htmlFor="effort">3</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="effort" className="form-check-input" type="radio" value="4" required/> 
                        <label htmlFor="effort">4</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="effort" className="form-check-input" type="radio" value="5" required/> 
                        <label htmlFor="effort">5</label>
                    </div>
                  </div>
                </div>

                <div className="col-form-label">
                  <label htmlFor="realistic">Did you find the prediction task realistic? (1-Not at all, 5-A lot)</label><br />
                  <div className="radio">
                    <div className="form-check form-check-inline">
                        <Field name="realistic" className="form-check-input" type="radio" value="1" required/> 
                        <label htmlFor="realistic">1</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="realistic" className="form-check-input" type="radio" value="2" required/> 
                        <label htmlFor="realistic">2</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="realistic" className="form-check-input" type="radio" value="3" required/> 
                        <label htmlFor="realistic">3</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="realistic" className="form-check-input" type="radio" value="4" required/> 
                        <label htmlFor="realistic">4</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="realistic" className="form-check-input" type="radio" value="5" required/> 
                        <label htmlFor="realistic">5</label>
                    </div>
                  </div>
                </div>

                <div className="col-form-label">
                  <label htmlFor="knowledge">What is your level of financial knowledge? (1-Well below average, 5-Well above average) </label><br />
                  <div className="radio">
                    <div className="form-check form-check-inline">
                        <Field name="knowledge" className="form-check-input" type="radio" value="1" required/> 
                        <label htmlFor="knowledge">1</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="knowledge" className="form-check-input" type="radio" value="2" required/> 
                        <label htmlFor="knowledge">2</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="knowledge" className="form-check-input" type="radio" value="3" required/> 
                        <label htmlFor="knowledge">3</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="knowledge" className="form-check-input" type="radio" value="4" required/> 
                        <label htmlFor="knowledge">4</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <Field name="knowledge" className="form-check-input" type="radio" value="5" required/> 
                        <label htmlFor="knowledge">5</label>
                    </div>
                  </div>
                </div>

                
                <div className="col-form-label">
                  <label htmlFor="free_text">Share additional thoughts/problems </label><br />
                  <div className="text-area">
                      <Field name="free_text" render={({ field }) => (<textarea{...field} placeholder="Enter text"  rows={5} cols={50}/>)}/>
                  </div>
                </div>

                <div className="text-center">
                  <Button variant="outline-light" className="surveybutton" type="submit">Submit</Button>
                </div>
              </Form>
            )}
          </Formik>     
        </div>
      </div>
    );
}

